import { gql } from "@apollo/client";
import { messageHeaders } from "features/common/fragments";
import { insuranceData } from "features/insuranceDocument/queries/fragments";

export const DOCUMENT_NAVIGATION_STEP_CHANGED = gql`
  subscription documentNavigationStepChanged($documentId: Int!) {
    documentNavigationStepChanged(documentId: $documentId) {
      documentId
      navigationStepId
      silentMode
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const INSURANCE_DOCUMENT_UPDATED = gql`
  subscription insuranceDocumentUpdated($documentId: Int!) {
    insuranceDocumentUpdated(documentId: $documentId) {
      insuranceData {
        ...insuranceData
      }
      silentMode
      headers {
        ...messageHeaders
      }
    }
  }
  ${insuranceData}
  ${messageHeaders}
`;

export const PARTNERS_CHANGED = gql`
  subscription partnersChanged {
    partnersChanged {
      documentId
      insuredId
      clientId
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const GENERATION_STATUS_CHANGED = gql`
  subscription generationStatusChanged($documentId: Int!) {
    generationStatusChanged(documentId: $documentId) {
      documentId
      generationInProgress
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;
